export const getMessage = ({ itemsCount, itemName }) => {
    const title = itemsCount === 1 ? itemName : `${itemName}s`;
    return `${itemsCount} ${title} selected`;
};
